import React, { FC, useEffect } from 'react';
import { EnterpriseCardTitle } from '../../../../../enterprise/card/EnterpriseCardTitle';
import { EnterpriseDetails } from '../../../../../enterprise/card/EnterpriseDetails';
import { EntepriseFollowButton } from '../../../../../enterprise/follow-button/EntepriseFollowButton';
import { Spacing } from '../../../../../components/entities-card/Spacing';
import { EntitiesCardBody } from '../../../../../components/entities-card/EntitiesCardBody';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';
import { Connect, PropsFromRedux } from './EnterpriseSnippetContainer';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import { ResultsType } from '../../../../state/reducers/results.types';
import { useRestrictedModal } from '../../../../../components/modal/useRestrictedModal';
import { useUser } from '../../../../../user/useUser';
import { Paper } from '../../../../../components/paper/Paper';
import styles from './enterprise_snippet.module.scss';

type Props = {
  enterprise: NonNullable<ResultsType['snippets']['enterprise']>;
} & PropsFromRedux;

export const RawEnterpriseSnippet: FC<Props> = ({
  originalQueryKey,
  enterprise,
}) => {
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();

  useEffect(() => {
    doctrineAnalytics('Search EnterpriseDisplayed', {
      enterprise_id: enterprise.enterpriseId,
      query_key: originalQueryKey,
    });
  }, []);

  const handleClick = (source: string) => () => {
    if (!accessPremium) {
      openRestrictedModal({ source });
    }
  };

  return (
    <Paper level={0} className={styles.container}>
      <EntitiesCardBody>
        <EnterpriseCardTitle
          onClick={handleClick('search_enterprise_snippet-header')}
          href={
            accessPremium
              ? buildUrlWithParameters(enterprise.url, {
                  original_query_key: originalQueryKey,
                  source: 'search_enterprise_snippet-header',
                })
              : undefined
          }
        >
          {enterprise.raisonSociale}
        </EnterpriseCardTitle>
        <Spacing />
        <EnterpriseDetails enterprise={enterprise} />
        <Spacing />
        <EntepriseFollowButton
          raisonSociale={enterprise.raisonSociale}
          enterpriseId={enterprise.enterpriseId}
        />
      </EntitiesCardBody>
    </Paper>
  );
};

export const EnterpriseSnippet = Connect(RawEnterpriseSnippet);
